import { FormEvent, useState } from "react";
import { posthog } from '../../../lib/posthog';
import { buildPublicAppUrl } from "../../../services/apiUrl";
import { requestPasswordReset } from "../api/adminAuthApi";
import { AuthField } from "../components/AuthField";
import { AuthShell } from "../components/AuthShell";
import { AuthStatusMessage } from "../components/AuthStatusMessage";
import { AuthSubmitButton } from "../components/AuthSubmitButton";
import { navigateTo } from "../components/authNavigation";

function getResetRedirectUrl(): string {
  return buildPublicAppUrl("/admin/reset-password");
}

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setError(null);
    setSuccess(null);
    posthog.capture('auth_password_reset_requested', { email });
    setIsSubmitting(true);

    try {
      const result = await requestPasswordReset({
        email,
        redirectTo: getResetRedirectUrl(),
      });

      if (!result.ok) {
        setError(result.error.message);
        return;
      }

      setSuccess("If that email exists, a reset link is on its way.");
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <AuthShell
      title="Reset Workspace Password"
      subtitle="Enter your email and we'll send you a secure reset link for your workspace account."
      badgeIcon="key"
      badgeLabel="Metaphysical Labs"
      data-oid="s8p24:4"
    >
      <form className="auth-form" onSubmit={handleSubmit} data-oid="ij6ao6_">
        <AuthField
          label="Email"
          name="email"
          type="email"
          autoComplete="email"
          placeholder="admin@example.com"
          leadingIcon="mail"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          data-oid="duj13vz"
        />

        {error ? (
          <AuthStatusMessage tone="error" message={error} data-oid="dhofftc" />
        ) : null}
        {success ? (
          <AuthStatusMessage
            tone="success"
            message={success}
            data-oid="xy7ed1t"
          />
        ) : null}
        <AuthSubmitButton
          type="submit"
          isBusy={isSubmitting}
          busyLabel="Sending Reset Link..."
          data-oid="z1.px7-"
        >
          Send Reset Link
        </AuthSubmitButton>
      </form>
      <p className="auth-footer-copy" data-oid="nmdlcty">
        Remember your password?{" "}
        <button
          className="auth-link-button"
          type="button"
          onClick={() => navigateTo("/admin/sign-in")}
          data-oid="cs_dnqq"
        >
          Sign In
        </button>
      </p>
    </AuthShell>
  );
}
